import React from 'react';

import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import dataFaq from '../assets/fake-data/data-faq';
import dataPortfolio from '../assets/fake-data/data-portfolio2';
import dataRoadMap from '../assets/fake-data/data-roadmap';

import Action from '../components/layouts/Action';
import Portfolio2 from '../components/layouts/Portfolio2';
import RoadMap from '../components/layouts/RoadMap';
import img from '../assets/images/items/group-nft-01.png'

const RoadMapMain = () => {
    return (
        <div className='roadmap'>
            <Header />
            <section className="tf-section page-title">
                <div className="container">
                    <div className="col-md-12">
                        <div className="page-title__body rm">
                            <div className="block-text pt-12">
                                <h2 className="sub-title mb-20">Road Map</h2>
                                <p className="fs-24 mb-33" >Follow the adventure, utility, <br/> and absolute greatness with <br /> The CryptoSkunkz NFT collection!<br/><br/> ** Roadmap subject to change ** </p>
                            </div>
                            <img className="s2" src={img} alt="SkunkzNFT" />
                        </div>
                    </div>
                </div>
            </section>
            <RoadMap data={dataRoadMap} />
            <Action />
            <Footer />
        </div>
    );
}

export default RoadMapMain;